import { conditions } from "../../helpers/conditions/conditions";
import { handleVideoType, responseValidator } from "../../helpers/helpers";
import { ConditionName } from "../../interfaces/enums";
import { apiCaller } from "../../services/apiCaller";
import { API } from "../../services/services";
import store from "../store";
import { handleHasXTokenParamOrSendXToken } from "../../helpers/helpers";
import { setBookamrks, setBookmarkId } from "../slices/userSlice";
import { IBookmark, ITokens } from "../../interfaces/interfaces";
import { sendFluentLog } from "../../logs/fluentdLogger";
import { bookmarkLog } from "../../logs/logs";
import Cookies from "js-cookie";
import { toast } from "mobin-toast";

export const createSettings = async (settings: any) => {
    settings = { ...settings, quality: conditions(ConditionName.isAutoQuality) ? null : settings.quality };
    if (conditions(ConditionName.isLogin) && conditions(ConditionName.trackerEnabled))
        await apiCaller({ url: API().user.createSettings, method: "POST", data: settings, headers: handleHasXTokenParamOrSendXToken() });
};

export const createVideoSettings = async (videoSettings: any) => {
    const { params, details } = store.getState().videoData;
    if (conditions(ConditionName.isLogin) && conditions(ConditionName.trackerEnabled))
        await apiCaller({
            url: API().user.createVideoMetaData,
            method: "POST",
            data: {
                video_id: videoSettings.video_id ?? conditions(ConditionName.isLiveParam) ? details.id : +params.id!,
                video_type: videoSettings.video_type ?? handleVideoType(),
                ...videoSettings
            },
            headers: handleHasXTokenParamOrSendXToken()
        });
};

export const handleBookmark = async (event: any, id?: number, type?: string) => {
    event.stopPropagation();
    if (conditions(ConditionName.hasXToken)) {
        const dispatch = store.dispatch;
        const { bookmarks, bookmarkId } = store.getState().user;
        if (conditions(ConditionName.isBookmark) || type === "delete") {
            if (conditions(ConditionName.trackerEnabled)) {
                const { status, data } = await apiCaller({
                    url: API().user.deleteBookmark(id),
                    method: "DELETE",
                    headers: handleHasXTokenParamOrSendXToken()
                });
                if (responseValidator(status)) {
                    dispatch(setBookamrks(bookmarks.filter((bookmark: IBookmark) => (id ? bookmark.id !== id : bookmark.id !== bookmarkId))));
                    dispatch(setBookmarkId(undefined));
                    sendFluentLog(bookmarkLog("unBookmark"));
                } else toast({ type: "error", title: data.detail });
            }
        } else {
            const { details } = store.getState().videoData;
            const bookmarkData = {
                object_link: window.location.href,
                cover_url: details.banner,
                title: details.title
            };
            if (conditions(ConditionName.trackerEnabled)) {
                const { data, status } = await apiCaller({
                    url: API().user.bookmarks,
                    method: "POST",
                    data: bookmarkData,
                    headers: handleHasXTokenParamOrSendXToken()
                });
                if (responseValidator(status)) {
                    dispatch(setBookamrks([data, ...bookmarks]));
                    dispatch(setBookmarkId(data.id));
                    sendFluentLog(bookmarkLog("bookmark"));
                } else toast({ type: "error", title: data.detail });
            }
        }
    } else toast({ title: "لطفا ابتدا وارد شوید.", type: "error" });
};

export const authToken = {
    key: "HAMRAHI_CLOUD_AUTH_TOKEN",
    get: (): ITokens | null => {
        const data = Cookies.get(authToken.key);
        if (data) return JSON.parse(data);
        return null;
    },
    set: (value: ITokens) => Cookies.set(authToken.key, JSON.stringify(value), { expires: 1095, sameSite: "none", secure: true }),
    remove: () => Cookies.remove(authToken.key)
};

export const captchaStorageLogin = {
    key: "HAMRAHI_CLOUD_LANDING_AUTH_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(captchaStorageLogin.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(captchaStorageLogin.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(captchaStorageLogin.key);
    }
};

export const captchaStorageCode = {
    key: "HAMRAHI_CLOUD_LANDING_CODE_CAPTCHA",
    get: function (): string | null {
        const data = localStorage.getItem(captchaStorageCode.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: string) => {
        localStorage.setItem(captchaStorageCode.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(captchaStorageCode.key);
    }
};
